module.exports = {"422825100":"珠山镇","422825101":"椒园镇","422825102":"沙道沟镇","422825103":"李家河镇","422825104":"高罗镇","422825200":"万寨乡","422825201":"长潭河侗族乡","422825203":"晓关侗族乡","422825205":"椿木营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422825.json
// module id = 1920
// module chunks = 0